<template>
  <div class="login-wrap">
    <div id="backgroun">
      <div class="ms-login">
        <img src="@/assets/image/login_header.jpg" alt width="150" height="150" />
        <div class="title">登录</div>
        <el-form :model="form" label-width="0px" class="demo-ruleForm">
          <el-form-item>
            <el-input placeholder="管理员帐号" clearable v-model.trim="form.account"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              type="password"
              placeholder="管理员密码"
              v-model.trim="form.password"
              clearable
              @keyup.enter.native="login"
              @keyup.13="login"
            ></el-input>
          </el-form-item>
          <div class="login-btn">
            <el-button type="primary" @click="login">登 录</el-button>
          </div>
          <!-- <p class="reg" @click="jumpeReg">注 册</p> -->
          <!-- <p class="tips">提示 : 默认账户admin,密码123456</p> -->
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "@/api/login";
export default {
  data: function() {
    return {
      form: {
        account: "",
        password: ""
      }
    };
  },
  methods: {
    /**
     * 登录
     */
    login() {
      if (this.form.account == "" || this.form.password == "") {
        this.$message.error("帐号或密码不能为空");
      } else {
        login(this.form).then(res => {
          this.$message({
            type: "success",
            message: "登录成功"
          });
          this.$store.dispatch("userinfo", res.data.admin);
          localStorage.setItem("xw_userinfo", JSON.stringify(res.data.admin));
          this.$router.replace("/home");
        });
      }
    },
    /**
     * 跳转到注册
     */
    jumpeReg() {
      this.$router.push("/register");
    }
  }
};
</script>

<style scoped>
#backgroun {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #fff;
  background-image: url("../../assets/image/login_background.jpg");
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title {
  text-align: center;
  color: #444;
  padding: 20px 0;
  font-size: 1.2rem;
  font-weight: bold;
  font-family: inherit;
  letter-spacing: 3px;
}

.ms-login img {
  text-align: center;
}
.ms-login {
  /* position: absolute;
  left: 50%;
  top: 40%;
  width: 300px;
  margin: -150px 0 0 -190px; */
  width: 300px;
  padding: 40px;
  border-radius: 5px;
  background: #fff;
  text-align: center;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
}
.tips {
  font-size: 12px;
  line-height: 30px;
  color: #999;
}

.reg {
  color: #409eff;
  font-size: 0.9rem;
  cursor: pointer;
}

@media screen and (max-width: 999px) {
  .ms-login {
    margin-bottom: 25%;
  }
}

@media screen and (min-width: 1000px) and (max-width: 1299px) {
  .ms-login {
    margin-bottom: 18%;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1659px) {
  .ms-login {
    margin-bottom: 10%;
  }
}

@media screen and (min-width: 1300px) and (max-width: 1660px) {
  #backgroun {
    background-size: contain;
  }
}

@media screen and (min-width: 1661px) {
  #backgroun {
    background-size: cover;
  }
}
</style>